/* TODO: Update the TranslationKeys interface to a recursive structure to properly support imports here
 * https://github.com/decentraland/decentraland-dapps/blob/master/src/modules/translation/types.ts#L5
 */
/* eslint-disable @typescript-eslint/no-var-requires */
const en = require('./en.json')
const es = require('./es.json')
const zh = require('./zh.json')

export { en, es, zh }
